module.exports = __webpack_public_path__ + "static/shop-964516dd981b8fff8e00024f27c7deed.jpg";